import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSkip5SecondsForward16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSkip5SecondsForward16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5.915 2.276a.55.55 0 0 0-.736 0 .453.453 0 0 0 0 .677L6.316 4H4.5A2.5 2.5 0 0 0 2 6.5v4A2.5 2.5 0 0 0 4.5 13H7a.5.5 0 1 0 0-1H4.5A1.5 1.5 0 0 1 3 10.5v-4A1.5 1.5 0 0 1 4.5 5h1.816L5.179 6.047a.453.453 0 0 0 0 .677.55.55 0 0 0 .736 0L7.962 4.84a.453.453 0 0 0 0-.678zm5.914 6.87c.68 0 1.16-.498 1.165-1.033.005-.573-.4-1.025-.887-1.025-.476 0-.822.109-1.04.21a1.6 1.6 0 0 0-.286.167l-.006.005a.5.5 0 0 1-.833-.372v-3.04h2.997a.5.5 0 1 1 0 1h-1.997v1.214a3.6 3.6 0 0 1 1.165-.184c1.178 0 1.895 1.05 1.887 2.033-.01 1.153-1.006 2.025-2.165 2.025-.553 0-.98-.15-1.274-.307a2.2 2.2 0 0 1-.432-.301l-.028-.028-.01-.01-.004-.004-.002-.001v-.001l.363-.344-.364.343a.5.5 0 0 1 .722-.691l.004.003.037.032c.038.03.1.074.185.12.17.09.437.189.803.189"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSkip5SecondsForward16);
